import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import axios from "axios";

// Dashboard Layout
import DashboardSidebar from "../../components/dashboard components/DashboardSidebar";
import DashboardHeader from "../../components/dashboard components/DashboardHeader";

// Form Component
import FooterForm from "../../components/dashboard components/forms/FooterForm";

// ✅ Use environment variable for API base
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Footer = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // ===================
  // Data States
  // ===================
  const [footerData, setFooterData] = useState({
    company_description: "",
    address: "",
    phone: "",
    phone1: "",
    email: "",
    facebook_url: "",
    twitter_url: "",
    linkedin_url: "",
    youtube_url: "",
    disclaimer_text: "",
    copyright_note: "",
  });

  // ===================
  // Fetch Footer (on load)
  // ===================
  useEffect(() => {
    const fetchFooter = async () => {
      try {
        const { data } = await axios.get(`${API_BASE_URL}/footer/get`);
        console.log("FOOTER API DATA:", data);
        if (data) {
          setFooterData({
            company_description: data.company_description || "",
            address: data.address || "",
            phone: data.phone || "",
            phone1: data.phone1 || "",
            email: data.email || "",
            facebook_url: data.facebook_url || "",
            twitter_url: data.twitter_url || "",
            linkedin_url: data.linkedin_url || "",
            youtube_url: data.youtube_url || "",
            disclaimer_text: data.disclaimer_text || "",
            copyright_note: data.copyright_note || "",
          });
        }
      } catch (error) {
        console.error("❌ Error fetching footer:", error);
      }
    };
    fetchFooter();
  }, []);

  // ===================
  // Save Handler
  // ===================
  const handleSave = async () => {
    try {
      await axios.post(`${API_BASE_URL}/footer/update`, footerData);
      alert("✅ Footer details saved successfully!");
    } catch (error) {
      console.error("❌ Error saving footer:", error);
      alert("Failed to save footer details. Please check console for errors.");
    }
  };

  // ===================
  // Return JSX
  // ===================
  return (
    <div className="flex min-h-screen bg-gray-50 font-sans">
      {/* Sidebar - Desktop */}
      <div className="hidden lg:block">
        <DashboardSidebar activeSection="footer" />
      </div>

      {/* Sidebar - Mobile */}
      <div
        className={`fixed inset-y-0 left-0 bg-white w-72 shadow-2xl transform transition-transform duration-300 ease-in-out z-50 ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        } lg:hidden`}
      >
        <DashboardSidebar activeSection="footer" />
        <button
          className="absolute top-4 right-4 text-gray-500 hover:text-blue-600"
          onClick={() => setSidebarOpen(false)}
        >
          <X size={28} />
        </button>
      </div>

      {/* Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}

      {/* Main Content */}
      <main className="flex-1 flex flex-col w-full">
        {/* Header */}
        <div className="sticky top-0 bg-white z-30 shadow-sm flex items-center justify-between px-4 sm:px-8 py-4 border-b border-gray-200">
          {/* Sidebar Toggle (Mobile) */}
          <button
            className="lg:hidden text-gray-700 hover:text-blue-600 focus:outline-none"
            onClick={() => setSidebarOpen(true)}
          >
            <Menu size={28} />
          </button>

          {/* Page Title */}
          <div className="flex-1 flex justify-center">
            <DashboardHeader title="Footer Management" backTo="/dashboard" />
          </div>
        </div>

        {/* Content */}
        <section className="flex-1 overflow-y-auto px-4 sm:px-8 md:px-10 py-6 sm:py-10 bg-gray-50">
          <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-lg p-4 sm:p-6 md:p-8 border border-gray-100">
            <FooterForm
              footerData={footerData}
              setFooterData={setFooterData}
              onSave={handleSave}
            />
          </div>
        </section>
      </main>
    </div>
  );
};

export default Footer;
